declare global {
	interface Window {
		fcWidget: any;
	}
}

import React from 'react';
import { Button } from '@welbe/design-system';

import { ReactComponent as RedHeartIllustration } from './assets/heart-red-psychology.svg';
import {
	Container,
	ContainerButtons,
	Description,
	Title,
} from './NotificationPsychology.styles';
import Analytics from 'helpers/analytics';

interface NotificationPsychologyProps {
	onClose?: () => void;
}

const URL_SUPPORT_WHATSAPP =
	'https://api.whatsapp.com/send/?phone=%2B5215633064096&text&type=phone_number&app_absent=0';

const openNewTabSupportWhatsapp = () => {
	window.open(URL_SUPPORT_WHATSAPP, '_blank');
};

export const NotificationPsychology = ({
	onClose,
}: NotificationPsychologyProps) => {
	const handleOpenChat = () => {
		if (window.fcWidget) {
			window.fcWidget.open();
			Analytics.track('campaign', 'Psychology ad open chat');
		} else {
			openNewTabSupportWhatsapp();
			Analytics.track('campaign', 'Psychology ad open whats');
		}
		onClose && onClose();
	};
	return (
		<Container>
			<Title>Brinda a tus colaboradores atención psicológica</Title>
			<RedHeartIllustration />
			<Description>
				Para atender adecuadamente a tus colaboradores que requieren atención,
				es recomendable referirlos a un especialista en psicología. Conoce la
				solución que te ofrece Welbe.
			</Description>
			<ContainerButtons>
				<Button onClick={handleOpenChat}>Más información</Button>
				<Button variant="ghost" onClick={onClose}>
					En otro momento
				</Button>
			</ContainerButtons>
		</Container>
	);
};
